import React, { useState, useEffect, useRef } from "react";

// Components
import Breadcrumbs from "../../../components/Breadcrumbs";
import DataTable from "../../../components/Content/DataTable";
import DateFilterTable from "../../../components/Content/DateFilterTable";

// Date & Time
import moment from "moment";

// Utils
import { getAlert } from "../../../../utils/SamuiUtils";

function Main({
  masterList,
  statusColours,
  name,
  onPageInsert,
  onRowSelected,
  getReport,
}) {
  const [dataMasterList, setDataMasterList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(localStorage.getItem('itemsPerPageDropdown') || 10);
  const [countWaitConfirm, setCountWaitConfirm] = useState(0);
  const [countConfirm, setCountConfirm] = useState(0);
  const [countDeposit, setCountDeposit] = useState(0);
  const [countCancel, setCountCancel] = useState(0);

  const [searchTerm, setSearchTerm] = useState(localStorage.getItem('searchTerm') || '');
  const [filteredItems, setFilteredItems] = useState([]);

  const [startDate, setStartDate] = useState(() => {
    const storedStartDate = localStorage.getItem('startDate');
    return storedStartDate || moment().startOf('month').format('YYYY-MM-DD');
  });
  const [endDate, setEndDate] = useState(() => {
    const storedEndDate = localStorage.getItem('endDate');
    return storedEndDate || moment().endOf('month').format('YYYY-MM-DD');
  });
  const [dateType, setDateType] = useState('1');

  const [selectedStatus, setSelectedStatus] = useState(null);

  // สร้าง ref สำหรับ input ค้นหา
  const searchInputRef = useRef(null);

  useEffect(() => {
    initialize();
  }, [masterList]);

  useEffect(() => {
    setCurrentPage(1);
    filterItems();
  }, [searchTerm, dataMasterList, selectedStatus]);

  useEffect(() => {
    filterItems();
  }, [startDate, endDate, searchTerm, masterList, selectedStatus]);

  // Event listener สำหรับปุ่ม F5
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'F5') {
        event.preventDefault(); // ป้องกันการ refresh หน้า
        if (searchInputRef.current) {
          searchInputRef.current.focus();
          searchInputRef.current.select();
        }
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    // cleanup function
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  const initialize = async () => {
    try {
      if (masterList && masterList.length > 0) {
        setDataMasterList(masterList);

        let statusCounts = {
          รอยืนยัน: 0,
          "ลค ยืนยันแล้ว": 0,
          จ่ายมัดจำแล้ว: 0,
          ยกเลิก: 0,
        };

        masterList.forEach((data) => {
          if (data.DocStatus_Name) {
            statusCounts[data.DocStatus_Name] =
              (statusCounts[data.DocStatus_Name] || 0) + 1;
          }
        });

        setCountWaitConfirm(statusCounts["รอยืนยัน"]);
        setCountConfirm(statusCounts["ลค ยืนยันแล้ว"]);
        setCountDeposit(statusCounts["จ่ายมัดจำแล้ว"]);
        setCountCancel(statusCounts["ยกเลิก"]);
        setCurrentPage(1);
      }
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const handleStatusClick = (statusName) => {
    if (selectedStatus === statusName) {
      setSelectedStatus(null);
    } else {
      setSelectedStatus(statusName);
    }
  };

  const filterItems = () => {
    let filtered = masterList;

    const start = moment(startDate, "YYYY-MM-DD");
    const end = moment(endDate, "YYYY-MM-DD");

    filtered = filtered.filter(item => {
      const itemDate = dateType === '1'
        ? moment(item.Doc_Date, "YYYY-MM-DD")
        : moment(item.Doc_DueDate, "YYYY-MM-DD");
      return itemDate.isBetween(start, end, null, '[]');
    });

    if (searchTerm.trim() !== '') {
      const lowercasedSearchTerm = searchTerm.toLowerCase();
      filtered = filtered.filter(item =>
        Object.values(item).some(value => {
          if (typeof value === 'string') {
            return value.toLowerCase().includes(lowercasedSearchTerm);
          } else if (typeof value === 'number') {
            return value.toString().includes(searchTerm);
          }
          return false;
        })
      );
    }

    if (selectedStatus) {
      filtered = filtered.filter((item) => item.DocStatus_Name === selectedStatus);
    }

    setFilteredItems(filtered);
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredItems.slice(indexOfFirstItem, indexOfLastItem);

  return (
    <>
      <div className="page-header d-flex justify-content-between align-items-center mb-0">
        <Breadcrumbs
          page={name}
          items={[
            { name: "จัดซื้อสินค้า", url: "/purchase" },
            { name: name, url: "/deposit-document" },
          ]}
        />
      </div>
      <div className="row" style={{ maxHeight: "85vh", overflowY: "auto" }}>
        <div className="col-1">
          <center>
            <b>สถานะเอกสาร</b>
          </center>
          <br />
          {statusColours.map((statusObj, index) => {
            const { DocSetStaus_Name, DocSetColour } = statusObj;
            let count;

            switch (DocSetStaus_Name) {
              case "รอยืนยัน":
                count = countWaitConfirm;
                break;
              case "ลค ยืนยันแล้ว":
                count = countConfirm;
                break;
              case "จ่ายมัดจำแล้ว":
                count = countDeposit;
                break;
              case "ยกเลิก":
                count = countCancel;
                break;
              default:
                count = 0;
            }

            return (
              <div
                key={index}
                className="col-12 mb-3"
                onClick={() => handleStatusClick(DocSetStaus_Name)}
                style={{ cursor: "pointer" }}
              >
                <div
                  className="card text-center"
                  style={{
                    backgroundColor: DocSetColour,
                    boxShadow: selectedStatus === DocSetStaus_Name ? "0 0 15px rgba(0,0,0,0.5)" : "none",
                    border: selectedStatus === DocSetStaus_Name ? "2px solid #333" : "none",
                    transform: selectedStatus === DocSetStaus_Name ? "scale(1.05)" : "scale(1)",
                    transition: "transform 0.15s, box-shadow 0.15s, border 0.15s",
                  }}
                >
                  <div className="card-body d-flex flex-column align-items-center text-white">
                    <div className="row">
                      <div className="col-12">
                        <b style={{ fontSize: "20px", textAlign: "center" }}>
                          {count}
                        </b>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12">
                        <b style={{ fontSize: "16px", textAlign: "center" }}>
                          {DocSetStaus_Name}
                        </b>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        <div className="col-11">
          <div
            className="p-3 rounded-3 my-2 shadow-lg"
            style={{ backgroundColor: "#ffff" }}
          >
            <div className="row  mb-2">
              <div className="col-3">
                <div className="navbar-form nav-search">
                  <div className="input-group">
                    <input
                      ref={searchInputRef}
                      type="text"
                      placeholder="ค้นหาเอกสาร..."
                      className="form-control"
                      value={searchTerm}
                      onChange={(e) => {
                        setSearchTerm(e.target.value);
                        localStorage.setItem('searchTerm', e.target.value);
                      }}
                    />
                    <span className="input-group-text">
                      <i className="fas fa-search"></i>
                    </span>
                  </div>
                </div>
              </div>
              <div className='col-md-7 d-flex'>
                <DateFilterTable
                  startDate={startDate}
                  endDate={endDate}
                  setStartDate={setStartDate}
                  setEndDate={setEndDate}
                />
              </div>
              <div className="col-2 d-flex justify-content-end">
                <button
                  onClick={onPageInsert}
                  className="btn btn-warning text-white ms-2"
                  type="button"
                >
                  สร้าง{name} <i className="fa fa-plus"></i>
                </button>
              </div>
            </div>
          </div>
          <DataTable
            currentItems={currentItems}
            onRowSelected={onRowSelected}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            handlePageChange={handlePageChange}
            dataMasterList={filteredItems}
            setDataMasterList={setFilteredItems}
            itemsPerPage={itemsPerPage}
            setItemsPerPage={setItemsPerPage}
            fieldMappings={{
              no: "Doc_No",
              typeName: "DocType_Name",
              statusName: "DocStatus_Name",
              statusColor: "docsetcolour",
              printedStatus: 'Printed_Status',
              date: "Doc_Date",
              apCode: "AR_Code",
              apName: "AR_Name",
              dlLineName: "DL_LineName",
              dueDate: "Doc_DueDate",
              netTotal: "NetTotal",
              createdBy: "Created_By_Name",
              updatedBy: "Update_By_Name",
            }}
            getReport={(docNo) => {
              (async () => {
                try {
                  await getReport("depos", docNo);
                } catch (e) {
                  console.error(e);
                } finally {
                  await initialize();
                }
              })();
            }}
          />
        </div>
      </div>
    </>
  );
}

export default Main;
